import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css';
import honeywell from '../../assets/images/honeywell_w.png'
import $ from 'jquery';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { colourOptions } from './data/data';

const animatedComponents = makeAnimated();

class Videogrid extends React.Component {

    componentDidMount() {
        $(document).ready(function(){
            $('[data-toggle="tooltip"]').tooltip();   
          });
    }
    componentWillMount(){
        
    }
    render() {
        return (
            <div>

                {/* live user popup */}

                <div className="live_user-add" style={{display: "none"}}>
                <div className="c_container">
                    <div className="card">
                        <div className="card-body">
                        <button className="btn btn-round close">
                                        <svg fill="#B9312F" width="30px"  x="0px" y="0px" viewBox="0 0 512 512">
                                            		<path d="M437.019,74.981C388.668,26.628,324.378,0,256,0C187.62,0,123.333,26.628,74.981,74.98S0,187.62,0,256
			c0,68.381,26.628,132.668,74.981,181.02C123.332,485.372,187.62,512,255.999,512s132.669-26.628,181.02-74.98
			C485.371,388.667,512,324.38,512,256C512,187.619,485.371,123.332,437.019,74.981z M368.853,347.642
			c5.857,5.857,5.857,15.355,0,21.213c-2.93,2.929-6.768,4.393-10.607,4.393c-3.838,0-7.678-1.465-10.605-4.393L256,277.214
			l-91.641,91.641c-2.93,2.929-6.768,4.393-10.607,4.393c-3.838,0-7.678-1.465-10.605-4.393c-5.858-5.857-5.858-15.355,0-21.213
			l91.64-91.641l-91.64-91.641c-5.858-5.857-5.858-15.355,0-21.213c5.857-5.857,15.354-5.857,21.213,0L256,234.788l91.64-91.641
			c5.857-5.857,15.355-5.857,21.213,0c5.857,5.857,5.857,15.355,0,21.213l-91.641,91.641L368.853,347.642z"/>
</svg>
                                        </button>
                            <div className="text-center mt-3">
                                <div className="c_live_search_wrapper">
                                    <h3>Add people here</h3>
                                    <div className="mt-2">
                                <Select
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                defaultValue={[colourOptions[4], colourOptions[5]]}
                                isMulti
                                options={colourOptions}
                                />
                                </div>
                                <button type="button" className="btn btn-success mt-2" style={{width:'200px', margin:'0 0 0 auto'}} ><i className="mdi mdi-phone"></i> Call now</button>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                </div>

                {/* video call grid */}

                <div className="call_grid-wrapper" style={{display: "none"}}>
                    <div className="call_meet-container">
                    <div className="call_grid">
                        <div className="item">
                            {/* <div className="caller_meet-info">
                                <div className="caller_n">
                                    <span>R</span>
                                </div>

                                <p className="caller_name">Rohit Bharti</p>
                            </div> */}

                            <div className="vid_item">
                            <video playsinline="" autoplay="" muted="" loop="">
                            {/* <source src="https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-1080p.mp4" type="video/mp4" />  */}
                            </video>
                            </div>
                        </div>

                        <div className="item">
                            <div className="caller_meet-info">
                                <div className="caller_n">
                                    <span>S</span>
                                </div>

                                <p className="caller_name">Shubham Khanna</p>
                            </div>

                            {/* <div className="vid_item">
                            <video poster="http://simulanis.com/assets/img/home/home-banner.jpg" playsinline="" autoplay="" muted="" loop="">
                            <source src="http://simulanis.com/assets/video/Homepage-Video.mp4" type="video/mp4" /> 
                            </video>
                            </div> */}
                        </div>

                        <div className="item">
                            <div className="caller_meet-info">
                                <div className="caller_n">
                                    <span>A</span>
                                </div>

                                <p className="caller_name">Ankit Thapliyal</p>
                            </div>

                            {/* <div className="vid_item">
                            <video poster="http://simulanis.com/assets/img/home/home-banner.jpg" playsinline="" autoplay="" muted="" loop="">
                            <source src="http://simulanis.com/assets/video/Homepage-Video.mp4" type="video/mp4" /> 
                            </video>
                            </div> */}
                        </div>
                        </div>
               
                    </div>
                   <div className="call_footer">
                        <ul className="m-0 p-0">
                            <li>
                                <button className="btn btn-light btn-round">
                                    <i className="mdi mdi-microphone" data-toggle="tooltip" title="On microphone"></i>
                                    {/* mdi mdi-microphone-off */}
                                    </button>

                                <button className="btn btn-light btn-round ml-2" data-toggle="tooltip" title="Open camera"><i className="mdi mdi-video-off"></i>
                                {/* mdi mdi-video */}
                                </button>

                                <button className="btn btn-light btn-round ml-2" data-toggle="tooltip" title="Share your screen"><i className="mdi mdi-laptop"></i>
                                {/* mdi mdi-laptop-off */}
                                </button>

                                <button className="btn btn-danger btn-round ml-2" data-toggle="tooltip" title="Leave call"><i className="mdi mdi-phone-hangup"></i></button>

                            </li>
                        </ul>
                   </div>
                    </div>

                {/* call recevie */}
                
                <div className="call_recevier-container"  style={{display: "none"}}>
                <div className="call_recevier-wrapper" >
                    <div className="call_info" >
                    <div class="caller_grid" >   
                    {/* Add class - columns_caller_grid - into caller_grid to access multiple grid*/}
                        <div class="caller_grid_item">
                            <div className="c_g_item">
                            <div className="caller_pic">
                            <img src="https://picsum.photos/200/300" alt="caller-pic" />
                        </div>
                        <div className="info">
                        <h2 className="text-dark mt-3">Rohit Bharti</h2>
                            <p className="text-dark">rohitbharti@simulanis.com</p>
                            </div>
                            </div>
                        </div>
                        <div class="caller_grid_item">
                            <div className="c_g_item">
                            <div className="caller_pic">
                            <img src="https://picsum.photos/200/300" alt="caller-pic" />
                        </div>
                        <div className="info">
                        <h2 className="text-dark mt-3">Rohit Bharti</h2>
                            <p className="text-dark">rohitbharti@simulanis.com</p>
                            </div>
                            </div>
                        </div>
                        <div class="caller_grid_item">
                            <div className="c_g_item">
                            <div className="caller_pic">
                            <img src="https://picsum.photos/200/300" alt="caller-pic" />
                        </div>
                        <div className="info">
                        <h2 className="text-dark mt-3">Rohit Bharti</h2>
                            <p className="text-dark">rohitbharti@simulanis.com</p>
                            </div>
                            </div>
                        </div>
                        </div>
                        
                    <div className="caller_info text-center pt-3 pb-3 p-2">
                        <div className="c_i_b">
                        <p className="text-white m-0">Calling you</p>
                        <div class="spinner">
                            <div class="bounce1"></div>
                            <div class="bounce2"></div>
                            <div class="bounce3"></div>
                            </div>
                        </div>
                            

                            <div className="call_opt">
                                <button className="btn btn-danger"><i className="mdi mdi-phone-hangup"></i></button>
                                <button className="btn btn-success ml-3"><i className="mdi mdi-phone"></i></button>
                            </div>
                    </div>
                    </div>
                </div>
                </div>

                {/* calling window */}

                <div className="calling_window" style={{display: "none"}}>

                    <div className="calling_app-wrapper">

                    {/* add people */}
                    <div className="add_ppl text-center">
                    <button type="button" class="btn btn-round btn-light"><i class="mdi mdi-account-plus"></i> </button>
                        <p className="mt-1">Add people</p>
                    </div>


                    {/* Caller info */}

                    <div className="caller_info_grid" style={{gridTemplateColumns: "repeat(3, 1fr)",
                                                        gridGap: "1rem",
                                                        gridTemplateRows: "repeat(1, fr)"}}>
                        <div className="caller_info">
                    <div className="profile_avatar text-center">
                    <img src="https://picsum.photos/300/300" alt="user-profile" className="rounded-circle img-thumbnail  img-fluid" width="150px" />
                    <p className="user-name mt-2">Shubham Khanna</p>
                    </div>
                    </div>
                        <div className="caller_info">
                    <div className="profile_avatar text-center">
                    <img src="https://picsum.photos/300/300" alt="user-profile" className="rounded-circle img-thumbnail  img-fluid" width="150px" />
                    <p className="user-name mt-2">Shubham Khanna</p>
                    </div>
                    </div>
                        <div className="caller_info">
                    <div className="profile_avatar text-center">
                    <img src="https://picsum.photos/300/300" alt="user-profile" className="rounded-circle img-thumbnail  img-fluid" width="150px" />
                    <p className="user-name mt-2">Shubham Khanna</p>
                    </div>
                    </div>
                    </div>

                    {/* calling option */}

                    <div className="calling_opt">
                    <ul className="m-0">
                            <li>
                                <button className="btn btn-light btn-round text-dark">
                                    <i className="mdi mdi-microphone" data-toggle="tooltip" title="On microphone"></i>
                                    {/* mdi mdi-microphone-off */}
                                    </button>

                                    <button className="btn btn-danger btn-round ml-3" data-toggle="tooltip" title="Leave call"><i className="mdi mdi-phone-hangup"></i></button>

                                <button className="btn btn-light btn-round ml-3 text-dark" data-toggle="tooltip" title="Open camera"><i className="mdi mdi-video-off"></i>
                                {/* mdi mdi-video */}
                                </button>
                            </li>
                        </ul>
                    {/* <button className="btn ml-2" data-toggle="tooltip" title="Leave call"><i className="mdi mdi-phone-hangup"></i></button> */}
                    </div>

                    {/* logo */}
                    <div className="brand_logo">
                    <img src="/static/media/gailLogo.b4f56557.png" className="img-fluid" alt="logo"></img>
                    </div>

                    <div className="h-logo">
                    <img src={honeywell} className="img-fluid" alt="logo"></img>
                        </div>
                    
                    </div>
                </div>


                </div>
        )
    }
}
export default Videogrid
